/* @flow */
import React from 'react';
import AdminLayoutHeader from 'admin/components/AdminLayoutHeader.jsx';

type Props = {
  children: any,
}

import './styles/AdminLayout.scss';

function AdminLayout(props: Props) {
  return (
    <div className="AdminLayout">
      <AdminLayoutHeader />
      {props.children}
    </div>
  );
}

export default AdminLayout;



// WEBPACK FOOTER //
// ./src/admin/components/AdminLayout.jsx